<div fxLayout="column" fxFlex fusePerfectScrollbar>

    <mat-list class="date backdate" cdkFocusRegionStart>

        <div class="p-2" style="font-size: 24px;" fxLayoutAlign="center center">
            {{dia}}
        </div>

        <div class="p-4" style="font-size: 24px;" fxLayoutAlign="center center">
            {{fechaStr}}
        </div>

    </mat-list>

    <mat-divider cdkFocusRegionEnd></mat-divider>

    <mat-list>
        <div *ngFor="let event of itemsTotalizados">
            <div class="titulo">{{event.nombre}}</div>
            <div class="subtitulo">{{event.valor}}</div>
        </div>
    </mat-list>

    <mat-divider style="padding-bottom: 5%"></mat-divider>

    <div class="navbar-content">
        <fuse-navigation-right [navigation]="main2" [layout]="'vertical'"  class="material2"></fuse-navigation-right>
    </div>

</div>